import { Stack } from '@mui/material';
import { Title } from './Title';
import { Download } from './Download';
import { DynamicAdvancedCriteriaFilter } from './DynamicAdvancedCriteriaFilter';
import { DynamicAdvancedFilter } from './DynamicAdvancedFilter';
import { useIsDesktop } from 'Hooks';

export const Header = () => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      gap='40px'
      sx={{
        mt: isDesktop ? undefined : '16px',
        mb: '32px',
      }}
    >
      {isDesktop && <Title />}
      <DynamicAdvancedCriteriaFilter />
      <Stack direction='row' justifyContent='space-between'>
        <DynamicAdvancedFilter />
        <Download />
      </Stack>
    </Stack>
  );
};
